import React, { Component, useEffect } from 'react';
import Helmet from 'react-helmet';


const dataLayer = global.dataLayer;

class BlackFriday extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuccess: false
        }
        this.onSubmitBf = this.onSubmitBf.bind(this);
    }

    onSubmitBf(e) {
        e.preventDefault();

        const queryParams = new URLSearchParams(window.location.search);

        const utm_source = queryParams.get('utm_source');
        const utm_medium = queryParams.get('utm_medium');
        const utm_content = queryParams.get('utm_content');
        const utm_term = queryParams.get('utm_term');
        const utm_campaign = queryParams.get('utm_campaign');
        let gclid = queryParams.get('gclid');
        if (gclid != null) {
            gclid = "mlpstrk"
        }

        let formData = {
            emailAddress: e.target.emailAddress.value,
            elqFormName: e.target.elqFormName.value,
            elqSiteId: e.target.elqSiteId.value,
            elqCampaignId: e.target.elqCampaignId.value,
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_content: utm_content,
            utm_term: utm_term,
            utm_campaign: utm_campaign,
            gclid: gclid
        };

        global.dataLayer.push({
            event: 'Eloqua Form Submission',
            eventCategory: 'Lock It In',
            eventAction: global.location.pathname,
            eventLabel: e.currentTarget.textContent
        });

        try {

            let response = this.eloquaSubmit(formData);
        } catch (err) {
            console.log("Form Error: " + err);
            console.dir(formData);
        }

        this.setState({ showSuccess: true });
    }

    encodeFormData = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
            .join('&');
    }

    backToTop(e) {
        e.preventDefault();
        //window.scrollTo(0, 0);
        document.getElementById("content").scrollIntoView();
    }

    eloquaSubmit(formData) {

        return fetch(
            `https://s351095147.t.eloqua.com/e/f2`,
            {
                method: 'POST',
                mode: 'no-cors',
                body: this.encodeFormData(formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then(function (response) {
            return response;
        });


    }

    handleTabClick(e) {
        global.dataLayer.push({
            event: 'Black Friday',
            eventCategory: 'Black Friday',
            eventAction: 'Black Friday',
            eventLabel: e.currentTarget.textContent
        });
    }

    render() {
        const { showSuccess } = this.state;
        return (
            <div id="secure-your-savings" className="container black-friday position-relative text-white px-3 px-lg-5">
                <Helmet>
                    <title>Lock It In &#124; SentrySafe</title>
                    <meta name="description" content="If you locked in your discount, your coupon code has been emailed to you - be sure to use it by January 31st! If you missed out, don't worry. You can still get 10% off your first purchase by signing up for SentrySafe promotions and communications." />
                </Helmet>

                <div className="row p-0">
                    <div className="col position-relative py-3 py-lg-5">
                        <div className="border-bg"></div>
                    </div>
                </div>

                <div className="row p-0 z-top">
                    <div className="col md-7 p-0">
                        <h1 className="h1 mb-4 pb-2 mb-md-3 mt-3">
                            <span className="d-block">Lock in </span>
                            <span className="d-block">a Lifetime of Protection.</span>
                        </h1>
                        <div className="position-relative pl-md-5">
                            <div className="border-bg"></div>
                            <div className="pl-md-5 mb-4 mb-md-0 py-md-5">
                                <div className="row">
                                    <div className="col md-10">
                                        <h2 className="h2 mb-3 tt-none">Secure what matters most.</h2>
                                        <p className="pr-md-5 d-block pb-3">If you locked in your discount, your coupon code has been emailed to you &#45; be sure to use it by January 31st! If you missed out, don&#8217;t worry. You can still get 10&#37; off your first purchase by signing up for SentrySafe promotions and communications.</p>
                                        <a href="https://store.sentrysafe.com/" className="btn btn-primary" target="_blank">Shop Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="featured-product">
                    <img
                        className="bf-safe"
                        src={require('../../resources/img/features/bf-safe.png')}
                        alt=""
                    />
                    <img
                        className="bf-spotlight-desktop"
                        src="https://cdn.masterlock.com/sentrysafe/static/media/bf-spotlight-desktop.png"
                        alt=""
                    />
                    <img
                        className="bf-spotlight"
                        src="https://cdn.masterlock.com/sentrysafe/static/media/bf-spotlight-mobile.png"
                        alt=""
                    />
                </div>
                <div className="row p-0">
                    <div className="col p-0">
                        <h1 className="h1 my-4">
                            <span className="d-block">Lock in </span>
                            <span className="d-block">peace of mind.</span>
                        </h1>
                        <div className="position-relative pl-md-5">
                            <div className="border-bg"></div>
                            <div className="pl-md-5 pt-4 pb-5">
                                <div className="row position-relative pb-md-5">
                                    <div className="col md-5 ">
                                        <div className="mb-4">
                                            <img
                                                className="icon icon-1"
                                                src={require('../../resources/img/icons/flood.svg')}
                                                alt=""
                                            />
                                            <h3 className="h3 my-3 tt-none">Fires and floods happen. <br />Be ready when they do.</h3>
                                            <p>SentrySafe products lead the industry in water and fire protection &#45; so you can be sure your important items are safe.</p>
                                        </div>
                                    </div>
                                    <div className="col md-5">
                                        <div className="mb-4">
                                            <img
                                                className="icon icon-2 ml-3 ml-md-0"
                                                src={require('../../resources/img/icons/shield-check.svg')}
                                                alt=""
                                            />
                                            <h3 className="h3 my-3 tt-none">Protect what matters all year long.</h3>
                                            <p>Our line of security safes stand up to theft and burglary. So you can feel confident that any jewelry or priceless family heirlooms are kept safe and sound.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default BlackFriday;


// WEBPACK FOOTER //
// ./src/pages/lock-it-in/Index.js